module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-big.9f814420.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-big.png
// module id = 2929
// module chunks = 11